var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"flex-center header-selector",class:("i-menu-" + (_vm.minimized ? 'collapsed' : 'expanded')),on:{"click":function($event){return _vm.$emit('update:minimized', !_vm.minimized)}}})}
var staticRenderFns = []

export { render, staticRenderFns }